<template>
  <div v-loading="downLoading" element-loading-text="打印二维码中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
    style="height: 100%;width: 100%">
    <el-row style="height: 100%">
      <el-col :span="5" style="height: 100%">
        <div class="left-content">
          <div class="left-content-top">
            <div style="height: 40px;color: #1a1a1a">
              <strong>书籍选择</strong>
              <img :src="isLock ? require('../../assets/img/lock.png') : require('../../assets/img/unLock.png')" style="float:right;width: 15px;cursor: pointer" @click="clickLock" />
            </div>
            <div style="height: calc(100% - 50px);width: 100%;margin-top: 10px">
              <img style="width: 25px;margin-top: 10px" src="../../assets/img/bookIcon.png"/>
              <div v-if="isLock" style="font-size: 14px;margin: 10px 0 0 30px;width: calc(100% - 55px);float: right;cursor: pointer" @click="clickBook">{{ bookObj.name }}</div>
              <el-select v-else class="on_border_select" v-model="bookId" placeholder="请选择" @change="bookChange"
                         style="width: calc(100% - 35px);margin-left: 10px;float: right">
                <el-option
                  v-for="item in bookArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="left-content-bottom" v-loading="loading">
            <div style="height: 40px;color: #1a1a1a"><strong>章节目录</strong></div>
            <div style="height: calc(100% - 40px);overflow-y: auto">
              <el-tree
                highlight-current
                node-key="showId"
                :data="treeData"
                :props="defaultProps"
                :current-node-key="currentNodeKey"
                default-expand-all
                @node-click="handleTreeClick"
                :expand-on-click-node="false"
                ref="treeData">
              </el-tree>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="19" style="height: 100%" v-loading="loading">
        <div class="right-content">
          <div style="height: 80px;width: 100%;line-height: 80px">
            <div style="float: left"><strong style="color: #1a1a1a;font-size: 20px;margin-left: 20px">{{ selectNode.name }}</strong></div>
            <div v-if="selectNode.type === 0 && bookObj !== ''" style="float: left;width: 80px;height: 80px;margin-left: 20px">
              <vue-qr style="width: 100%;height: 100%" :text="bookObj.qrCode"></vue-qr>
            </div>
            <el-button class="save-button" style="float: right;margin-top: 20px;margin-left: 10px" @click="printCode">打印二维码</el-button>
            <el-button class="save-button" style="float: right;margin-top: 20px" @click="addChapter">新增</el-button>
          </div>
          <div style="height: calc(100% - 80px);width: 100%;overflow-y: auto">
            <div v-for="selectChapter in selectNode.chapterArr" :key="selectChapter.id" class="chapter-card">
              <el-form :model="selectChapter" label-width="95px" class="demo-ruleForm">
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="章节名称:" prop="name">
<!--                      <div>{{selectChapter.name}}</div>-->
                      <el-input v-model="selectChapter.name" disabled placeholder="请输入章节名称"></el-input>
                    </el-form-item>
                    <el-form-item label="排序:" prop="author">
                      <!--                      <div>{{selectChapter.sortNumber}}</div>-->
                      <el-input v-model="selectChapter.sortNumber" disabled placeholder="请输入排序"></el-input>
                    </el-form-item>
                    <el-form-item label="章节介绍:" prop="author">
                      <el-input type="textarea" rows="3" disabled resize="none" placeholder="请输入章节介绍"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <div style="height: 20px;width: 100%">
                      <img title="删除章节" src="../../assets/img/delete.png" style="float:right;width: 13px;margin-left: 10px;cursor: pointer" @click="deleteChapter(selectChapter)">
                      <img title="编辑章节" src="../../assets/img/edit.png" style="float:right;width: 14px;cursor: pointer" @click="editChapter(selectChapter)">
                    </div>
                    <div style="height: 170px;width: calc(100% - 20px);padding: 10px 0 0 20px">
                      <upload-video :chapterObj="selectChapter"></upload-video>
                    </div>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div v-show="false" v-for="qrCodeItem in qrCodeList" :key="qrCodeItem.id + '_' + qrCodeItem.name">
      <vue-qr style="width: 300px;height: 300px" :text="qrCodeItem.qrCode" :callback="qrCallBack" :qid="qrCodeItem.id + '_' + qrCodeItem.name"></vue-qr>
    </div>
    <el-dialog :title="addEditObj.addEditTitle" :visible.sync="addEditChapterShow" v-if="addEditChapterShow" width="700px" :show-close="true" :close-on-click-modal="false" center>
      <add-edit-chapter v-model="addEditChapterShow" :chapterObj="addEditObj" @getFatherChapter="getFatherChapter"></add-edit-chapter>
    </el-dialog>
  </div>
</template>

<script>
import {getBookList} from '../../api/book'
import {delBookChapter, getChapterListByBook} from '../../api/bookChapter'
import addEditChapter from '../../components/materialManagement/addEditChapter'
import uploadVideo from '../../components/materialManagement/uploadVideo'
import VueQr from 'vue-qr'

import JSZip from 'jszip'
import FileSaver from 'file-saver'

export default {
  name: 'contentManagement',
  components: {uploadVideo, addEditChapter, VueQr},
  data () {
    return {
      downLoading: false,
      loading: false,
      isLock: true,
      bookId: '',
      bookObj: '',
      bookArr: [],
      chapterArr: [],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      qrCodeList: [],
      currentNodeKey: '',
      selectNode: {
        row: '',
        name: '',
        type: -1,
        chapterArr: []
      },
      addEditObj: {
        row: '',
        child: '',
        isAdd: false,
        addEditTitle: '',
        type: 0
      },
      addEditChapterShow: false
    }
  },
  created () {
    this.getBookListData()
  },
  methods: {
    getBookListData () {
      let body = {
        pageIndex: 1,
        pageSize: 9999
      }
      getBookList(body).then(res => {
        this.bookArr = res.data.array
        this.bookId = this.bookArr[0].id
        this.bookObj = this.bookArr[0]
        this.getBookChapterListData()
      })
    },
    getBookChapterListData () {
      this.loading = true
      let that = this
      let showId = 1
      this.chapterArr = []
      let body = {
        pageIndex: 1,
        pageSize: 9999,
        bookId: this.bookId
      }
      getChapterListByBook(body).then(res => {
        let data = res.data
        let chapters = data.array
        chapters.filter(chapter => {
          chapter.showId = showId++
          that.chapterArr.push(chapter)
        })
        this.getTreeData()

        // this.getQrCodeList()
        if (this.selectNode && this.selectNode.row !== '') {
          if (this.selectNode.type === 0) {
            this.selectNode.chapterArr = this.chapterArr.filter(value => value.parentId === 0)
          } else {
            this.selectNode.chapterArr = this.chapterArr.filter(value => value.parentId === this.selectNode.row.id)
          }
        } else {
          this.selectNode.row = this.clone(this.bookObj)
          this.selectNode.name = this.selectNode.row.name
          this.selectNode.type = 0
          this.selectNode.chapterArr = this.chapterArr.filter(value => value.parentId === 0)
        }
        this.loading = false
      })
    },
    getTreeData () {
      let chapterArr = this.clone(this.chapterArr)
      this.treeData = chapterArr.filter(value => value.parentId === 0)
      for (let i = 0; i < this.treeData.length; i++) {
        this.treeData[i].children = this.getChildrenArr(this.treeData[i].id, chapterArr)
      }
    },
    getChildrenArr (parentId, chapterArr) {
      let that = this
      let arr = []
      chapterArr.filter(value => {
        if (value.parentId === parentId) {
          value.children = that.getChildrenArr(value.id, chapterArr)
          arr.push(value)
        }
      })
      return arr
    },
    getQrCodeList () {
      let that = this
      this.qrCodeList = []
      this.qrCodeList.push({id: this.bookObj.id, name: this.bookObj.name, qrCode: this.bookObj.qrCode, url: ''})
      this.chapterArr.filter(chapter => {
        if (chapter.videos && chapter.videos.length !== 0) {
          that.qrCodeList.push({
            id: chapter.id,
            name: chapter.name,
            qrCode: chapter.videos[0].qrCode,
            url: ''
          })
        }
      })
    },
    qrCallBack (dataUrl, qid) {
      let qids = qid.split('_')
      let id = parseInt(qids[0])
      let name = qids[1]
      let qrCodeItem = this.qrCodeList.find(qrCodeItem => qrCodeItem.id === id && qrCodeItem.name === name)
      if (qrCodeItem) {
        qrCodeItem.url = dataUrl
      }
    },

    clickLock () {
      this.isLock = !this.isLock
    },
    clickBook () {
      this.selectNode.row = this.clone(this.bookObj)
      this.selectNode.name = this.selectNode.row.name
      this.selectNode.type = 0
      this.selectNode.chapterArr = this.chapterArr.filter(value => value.parentId === 0)
    },
    bookChange () {
      this.bookObj = this.bookArr.find(book => book.id === this.bookId)
      this.selectNode.row = this.clone(this.bookObj)
      this.selectNode.name = this.selectNode.row.name
      this.selectNode.type = 0
      this.selectNode.chapterArr = this.chapterArr.filter(value => value.parentId === 0)
      this.getBookChapterListData()
    },
    handleTreeClick (data, node) {
      this.selectNode.row = this.clone(data)
      this.selectNode.name = this.selectNode.row.name
      this.selectNode.type = 1
      this.selectNode.chapterArr = this.chapterArr.filter(value => value.parentId === this.selectNode.row.id)
    },

    deleteChapter (item) {
      let name = item.name
      this.$confirm('此操作将永久删除该章节【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let id = item.id
        delBookChapter(id).then(res => {
          this.$message({
            message: '成功删除章节',
            type: 'success'
          })
          this.getFatherChapter()
        })
      })
    },
    addChapter () {
      this.addEditObj.isAdd = true
      this.addEditObj.row = this.selectNode.row
      this.addEditObj.type = this.selectNode.type
      this.addEditObj.addEditTitle = '新增章节'
      this.addEditChapterShow = true
    },
    editChapter (row) {
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditObj.type = this.selectNode.type
      this.addEditObj.addEditTitle = '编辑章节'
      this.addEditChapterShow = true
    },
    getFatherChapter () {
      let that = this
      setTimeout(function () {
        that.getBookChapterListData()
      }, 100)
    },
    printCode () {
      let that = this
      this.downLoading = true
      this.getQrCodeList()
      setTimeout(function () {
        that.print(that.qrCodeList)
      }, 1500)
    },
    print (qrCodeList) {
      const zip = new JSZip()
      qrCodeList.forEach(item => {
        const fileName = item.name + '.png'
        zip.file(fileName, item.url.substring(22), {base64: true})
      })
      this.downLoading = false
      zip.generateAsync({type: 'blob'}).then(content => {
        FileSaver.saveAs(content, this.bookObj.name + '_二维码.zip')
      })
    }
  }
}
</script>

<style scoped>
.left-content{
  width: 100%;
  height: 100%;
}
.right-content{
  margin-left: 10px;
  padding: 0 20px 0 20px;
  width: calc(100% - 50px);
  height: 100%;
}
.left-content-top{
  height: 110px;
  background-color: #fff;
  padding: 20px 20px 0 20px;
  box-shadow: 0 0 16px 0 rgba(169, 169, 169, 0.2);
  border-radius: 8px;
}
.left-content-bottom{
  margin-top: 20px;
  padding: 20px;
  height: calc(100% - 190px);
  background-color: #fff;
  box-shadow: 0 0 16px 0 rgba(169, 169, 169, 0.2);
  border-radius: 8px;
}

.on_border_input >>> .el-input__inner {
  border: 0;
}
.on_border_select >>> .el-input__inner {
  border: 0;
}

.chapter-card{
  width: calc(100% - 60px);
  height: 200px;
  margin: 10px 10px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 0 0 16px 0 rgba(169, 169, 169, 0.2);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/materialManagement/contentManagement.vue